import { render } from "./Resources.vue?vue&type=template&id=43f449a2&scoped=true"
import script from "./Resources.vue?vue&type=script&lang=js"
export * from "./Resources.vue?vue&type=script&lang=js"

import "./Resources.vue?vue&type=style&index=0&id=43f449a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aiden\\OneDrive - Qismat\\Development\\brydg-bdp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f449a2"]])

export default __exports__